export default "__VITE_ASSET__shpLbV_c__"